angular.module('internal.profile',[])
    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider.state('internal.profile', {
            url: '/profile',
            views: {
                'content': {
                    templateUrl: 'js/internal/profile/profile.view.html',
                    controller:'ProfileCtrl'
                }
            }
        });
    }]);